import { useQuery } from '@tanstack/react-query';
import {
  fetchBackstageAccess,
  fetchBackstageStats,
  fetchBackstageUsers,
  fetchBackstageHouseholds,
} from './api';

export function useBackstageAccess() {
  return useQuery({
    queryKey: ['backstage', 'access'],
    queryFn: fetchBackstageAccess,
  });
}

export function useBackstageStats() {
  return useQuery({
    queryKey: ['backstage', 'stats'],
    queryFn: fetchBackstageStats,
  });
}

export function useBackstageUsers() {
  return useQuery({
    queryKey: ['backstage', 'users'],
    queryFn: fetchBackstageUsers,
  });
}

export function useBackstageHouseholds() {
  return useQuery({
    queryKey: ['backstage', 'households'],
    queryFn: fetchBackstageHouseholds,
  });
}
